import React, {useEffect, useState, useCallback} from 'react';
import Modal from 'react-modal';
import fileSize from 'filesize';
import {useDropzone} from 'react-dropzone';
import {clientSideUpload} from "../helpers/FIleHelper";

const UploadFileModal = (props) => {
    const {
        show            = false,
        parentId        = "",
        disabled        = false,
        onCancel        = () => {},
        onComplete      = (files) => {},
        id              = "upload-file-modal",
        singleItemLabel = "Attachment",
        multiItemLabel  = "Attachments",
    } = props;

    const [files, setFiles] = useState([]);
    const [submitting, setSubmitting]   = useState(false);

    const onDrop = useCallback((acceptedFiles) => {
        setFiles([...acceptedFiles])
    }, [files])

    const {isDragActive, getRootProps, getInputProps} = useDropzone({
        onDrop
    });

    const reset = () => {
        setFiles([]);
        setSubmitting(false);
    }

    useEffect(() => {
        if (submitting) {
            submit();
        }
    }, [submitting]);

    const submit = async () => {
        const processed = [];
        for (let i = 0; i < files.length; i++) {
            processed.push(await clientSideUpload(files[i]));
        }

        onComplete(processed);
        reset();
    }

    const handleClose = () => {
        onCancel();
        reset();
    }

    const renderFile = (file) => {
        return (
            <div className={"file-details p-1"} key={file.path}>
                <div className={"name"}>{file.name}</div>
                <div className={"size"}>&nbsp;[{fileSize(file.size)}]&nbsp;</div>
                <div className={"type"}>{file.type}</div>
            </div>
        )
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleClose()}
            contentLabel={"Upload "+multiItemLabel}
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">{"Upload "+multiItemLabel}</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClose()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <div className="row m-0 p-0 d-flex justify-content-center">
                        <div className="col-12 m-0 p-0">
                            <div {...getRootProps({className: isDragActive ? 'dropzone file-uploader active text-eh-off-black p-4' : 'dropzone file-uploader text-eh-off-black p-4'})}>
                                <input {...getInputProps()} />
                                <span className="paper mr-3">
                                    <i className="fas fa-plus" />
                                </span>
                                {isDragActive ? "Drop "+multiItemLabel+" here" : "Select or drop "+multiItemLabel.toLowerCase()+" to upload"}
                            </div>
                            {!!files && files.length > 0 && (
                                <div className={"mt-3 selected-file-display"}>
                                    {!!files && files.map((file) => renderFile(file))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="submit"
                        className="btn btn-eh-lilac py-0 px-3 ml-0 py-0 mr-4"
                        onClick={() => setSubmitting(true)}
                        disabled={(files.length === 0) || submitting || disabled}
                    >
                        {"Upload"}
                    </button>
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => handleClose()}
                    >
                        {"Cancel"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default UploadFileModal;
